var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"basic-header"},[_c('div',{staticClass:"basic-header__content"},[_c('div',{staticClass:"basic-header__section basic-header__section--strong"},[_vm._v(" "+_vm._s(_vm.title)+" ")])])])}
var staticRenderFns = []

export { render, staticRenderFns }